import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Form } from 'react-bootstrap';
import { Input, Checkbox } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';
import ui from '../../common/services/ui';

const FromExistingForm = ({ fromExisting, changeFromExisting, noTeacherUsers, onSelectExistingUser, t }) => {
	
	return (
		<Form horizontal >
			<Field name='fromExisting' component={Checkbox} horizontal label={t('Teacher_FromExistingUser')} onChange={changeFromExisting} normalize={(v) => { return !!v }} />
			{ fromExisting && <Field name='fromUserId' component={Input} componentClass='select' horizontal required
				label={t('Teacher_FromUser')} validate={validators.required} onChange={onSelectExistingUser}>
				<option />
				{ui.makeOptionValues(noTeacherUsers)}
			</Field>}			
		</Form>
	);
};

export default reduxForm({ form: 'fromExisting' })(withTranslation()(FromExistingForm));
